import './DescriptionModal.css';

function DescriptionModal({ content, closeModal }) {
  return (
    <div
      className="description-modal-overlay"
      onClick={closeModal}
      role="dialog"
      aria-modal="true"
      aria-label="Project description"
    >
      <div
        className="description-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="description-modal-close"
          onClick={closeModal}
          aria-label="Close"
        >
          &times;
        </button>
        <p className="description-modal-text">{content}</p>
      </div>
    </div>
  );
}

export default DescriptionModal;
